import { takeEvery, takeLatest } from 'redux-saga/effects';
import { APPLICATION_MODULE } from '../../../configs/moduleNames';
import {
  ASSIGN_APPLICATION_BY_ID,
  CREATE_APPLICATION,
  DELETE_APPLICATION,
  EDIT_APPLICATION_BY_ID,
  LOAD_APPLICATION_BY_ID,
  LOAD_LIST,
  ARCHIVE_APPLICATION,
  UNARCHIVE_APPLICATION,
  LOAD_APPLICATION_STATUS,
  LOAD_SMEV_CHECK_LIST,
  SUSPENDED_APPLICATION,
  DENIED_APPLICATION,
  RETURN_APPLICATION,
  ACCEPT_APPLICATION,
  ANNULMENT_APPLICATION,
  SMEV_CHECK_ALL_APPLICATION,
  LOAD_APPLICATION_HISTORY,
  LOAD_AWAIT_DOCUMENT,
  LOAD_DOCUMENT_BY_ID,
  DELETE_DOCUMENT,
  GROUP_SIGN_FILE,
  GROUP_DELETE_FILE,
  SMEV_CHECK_APPLICATION,
  UN_ASSIGN_APPLICATION_BY_ID,
  REVIEW_APPLICATION,
  GENERATE_DOCX,
  APPLICATION_FIELDS_VALIDATION,
  RESTORE_APPLICATION,
  LOAD_LEGAL_ENTITY_FORM_LIST,
  SEARCH_INFO_BY_PARAM,
  LOAD_LIST_ID,
  EXPORT_APPLICATION,
  LOAD_APPLICANT_LIST,
  ACCEPT_APPLICANT,
  LOAD_AWAIT_DOCUMENTS_LIST_ID,
  BATCH_COMMAND,
  LOAD_PREVIEW_DOCUMENT, REGISTER_MAIS_EGU, MAIS_EGU_HISTORY, LOAD_REPRESENTATIVE_LIST,
} from '../actions';

import loadApplicationList from './loadApplicationList';
import createApplication from './createApplication';
import loadApplicationById from './loadApplicationById';
import editApplicationById from './editApplicationById';
import deleteApplication from './deleteApplication';
import restoreApplication from './restoreApplication';
import assignApplicationById from './assignApplicationById';
import archiveApplication from './archiveApplication';
import unarchiveApplication from './unarchiveApplication';
import loadApplicationStatus from './loadApplicationStatus';
import loadSmevCheckList from './loadSmevCheckList';
import acceptApplication from './acceptApplication';
import returnApplication from './returnApplication';
import deniedApplication from './deniedApplication';
import annulmentApplication from './annulmentApplication';
import smevCheckAllApplication from './smevCheckAllApplication';
import smevCheckApplication from './smevCheckApplication';
import loadApplicationHistory from './loadApplicationHistory';
import loadAwaitDocument from './loadAwaitDocument';
import loadDocumentById from './loadDocumentById';
import deleteDocument from './deleteDocument';
import groupSignFile from './groupSignFile';
import groupDeleteFile from './groupDeleteFile';
import suspendedApplication from './suspendedApplication';
import unAssignApplicationById from './unAssignApplicationById';
import reviewApplication from './reviewApplication';
import generateDocx from './generateDocx';
import applicationFieldsValidation from './applicationFieldsValidation';
import loadLegalEntityFormList from './loadLegalEntityFormList';
import searchInfoByParam from './searchInfoByParam';
import loadApplicationIdList from './loadApplicationIdList';
import exportApplication from './exportApplication';
import loadApplicantList from './loadApplicantList';
import acceptApplicant from './acceptApplicant';
import loadAwaitDocumentIdList from './loadAwaitDocumentIdList';
import applicationBatchCommand from './applicationBatchCommand';
import loadPreviewDocument from './loadPreviewDocument';
import registerMaisEgu from './registerMaisEgu';
import getHistoryMaisEguById from './getHistoryMaisEguById';
import loadRepresentativeList from './loadRepresentativeList';

export default function* watchDashboard() {
  yield takeLatest(APPLICATION_MODULE + LOAD_LIST, loadApplicationList);
  yield takeLatest(APPLICATION_MODULE + LOAD_LIST_ID, loadApplicationIdList);
  yield takeLatest(APPLICATION_MODULE + CREATE_APPLICATION, createApplication);
  yield takeEvery(APPLICATION_MODULE + LOAD_APPLICATION_BY_ID, loadApplicationById);
  yield takeEvery(APPLICATION_MODULE + EDIT_APPLICATION_BY_ID, editApplicationById);
  yield takeEvery(APPLICATION_MODULE + DELETE_APPLICATION, deleteApplication);
  yield takeEvery(APPLICATION_MODULE + RESTORE_APPLICATION, restoreApplication);
  yield takeEvery(APPLICATION_MODULE + ASSIGN_APPLICATION_BY_ID, assignApplicationById);
  yield takeEvery(APPLICATION_MODULE + ARCHIVE_APPLICATION, archiveApplication);
  yield takeEvery(APPLICATION_MODULE + UNARCHIVE_APPLICATION, unarchiveApplication);
  yield takeLatest(APPLICATION_MODULE + LOAD_APPLICATION_STATUS, loadApplicationStatus);
  yield takeEvery(APPLICATION_MODULE + LOAD_SMEV_CHECK_LIST, loadSmevCheckList);
  yield takeEvery(APPLICATION_MODULE + ACCEPT_APPLICATION, acceptApplication);
  yield takeEvery(APPLICATION_MODULE + RETURN_APPLICATION, returnApplication);
  yield takeEvery(APPLICATION_MODULE + DENIED_APPLICATION, deniedApplication);
  yield takeEvery(APPLICATION_MODULE + SUSPENDED_APPLICATION, suspendedApplication);
  yield takeEvery(APPLICATION_MODULE + ANNULMENT_APPLICATION, annulmentApplication);
  yield takeEvery(APPLICATION_MODULE + SMEV_CHECK_ALL_APPLICATION, smevCheckAllApplication);
  yield takeEvery(APPLICATION_MODULE + SMEV_CHECK_APPLICATION, smevCheckApplication);
  yield takeLatest(APPLICATION_MODULE + LOAD_APPLICATION_HISTORY, loadApplicationHistory);
  yield takeLatest(APPLICATION_MODULE + LOAD_AWAIT_DOCUMENT, loadAwaitDocument);
  yield takeEvery(APPLICATION_MODULE + LOAD_DOCUMENT_BY_ID, loadDocumentById);
  yield takeEvery(APPLICATION_MODULE + DELETE_DOCUMENT, deleteDocument);
  yield takeEvery(APPLICATION_MODULE + GROUP_SIGN_FILE, groupSignFile);
  yield takeEvery(APPLICATION_MODULE + GROUP_DELETE_FILE, groupDeleteFile);
  yield takeEvery(APPLICATION_MODULE + UN_ASSIGN_APPLICATION_BY_ID, unAssignApplicationById);
  yield takeEvery(APPLICATION_MODULE + REVIEW_APPLICATION, reviewApplication);
  yield takeEvery(APPLICATION_MODULE + GENERATE_DOCX, generateDocx);
  yield takeEvery(APPLICATION_MODULE + APPLICATION_FIELDS_VALIDATION, applicationFieldsValidation);
  yield takeLatest(APPLICATION_MODULE + LOAD_LEGAL_ENTITY_FORM_LIST, loadLegalEntityFormList);
  yield takeLatest(APPLICATION_MODULE + EXPORT_APPLICATION, exportApplication);

  yield takeLatest(APPLICATION_MODULE + SEARCH_INFO_BY_PARAM, searchInfoByParam);
  yield takeLatest(APPLICATION_MODULE + LOAD_APPLICANT_LIST, loadApplicantList);
  yield takeLatest(APPLICATION_MODULE + ACCEPT_APPLICANT, acceptApplicant);
  yield takeEvery(APPLICATION_MODULE + LOAD_AWAIT_DOCUMENTS_LIST_ID, loadAwaitDocumentIdList);
  yield takeEvery(APPLICATION_MODULE + BATCH_COMMAND, applicationBatchCommand);
  yield takeEvery(APPLICATION_MODULE + LOAD_PREVIEW_DOCUMENT, loadPreviewDocument);
  yield takeEvery(APPLICATION_MODULE + REGISTER_MAIS_EGU, registerMaisEgu);
  yield takeEvery(APPLICATION_MODULE + MAIS_EGU_HISTORY, getHistoryMaisEguById);
  yield takeEvery(APPLICATION_MODULE + LOAD_REPRESENTATIVE_LIST, loadRepresentativeList);
}
